<template>
  <div class="rank-table-container">
    <div class="header-content" style="align-items: center;">
      <div style="font-size: 24px;color: white;">快手互动玩法大数据</div>
      <div style="font-size: 20px;font-weight:bold;margin-top: 1%">{{ displayTime }}</div>
    </div>

    <!-- 加载中 -->
    <el-dialog
        v-model="isLoading"
        width="300px"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        custom-class="loading-dialog"
    >
      <div style="text-align:center; font-size: 24px; margin-bottom: 10px;">
        数据加载中，请稍后…
      </div>
      <div style="text-align:center;">
        <el-icon><loading /></el-icon>
      </div>
    </el-dialog>

    <!-- 第一行：开始/结束日期 -->
    <div style="text-align: center;margin-bottom: 10px; margin-top: 6%;padding-left: 16px;padding-right: 16px;border-radius: 8px;">
      <div class="datetime-container background-box" style="display: inline-flex; gap: 40px; justify-content: center;">
        <div class="datetime-group" style="display: inline-flex; align-items: center;">
          <label for="startDate" style="margin-right: 2%; margin-top:2%;margin-left: 2%">开始时间:</label>
          <span style="display:block;width:40%;margin-top: 1%;">
            <datetime
                input-style="width:100%;font-size:16px;"
                v-model="startDate"
                type="date"
                :format="{year:'numeric',month:'2-digit',day:'2-digit'}"
                :max-datetime="new Date().toISOString()"
                class="dt-input"
            />
          </span>
        </div>

        <div class="datetime-group" v-show="queryType === 'day'" style="display: inline-flex; align-items: center;">
          <label for="endDate" style="margin-right: 2%; margin-top:2%;margin-left: 2%">结束时间:</label>
          <span style="display:block;width:40%;margin-top: 1%;">
            <datetime
                input-style="width:100%;font-size:16px;"
                v-model="endDate"
                type="date"
                :format="{year:'numeric',month:'2-digit',day:'2-digit'}"
                :max-datetime="new Date().toISOString()"
                class="dt-input"
            />
          </span>
        </div>
      </div>
    </div>

    <!-- 第二行：查询控制 -->
    <div style="margin-bottom: 10px; text-align: center;padding-left: 16px;padding-right: 16px;border-radius: 8px;">
      <div class="form-row background-box" style="display: inline-flex; align-items: center; gap: 20px;">
        <el-radio-group v-model="queryType" style="display: inline-flex; gap: 2%; min-width: 40%; margin-left: 2%; margin-top: 1%;">
          <el-radio :value="'hour'">按小时查询</el-radio>
          <el-radio :value="'day'">按天查询</el-radio>
        </el-radio-group>

        <label style="min-width: 15%; margin-top:1%;margin-left: 2%">快速选择：</label>
        <el-button @click="showQuickSelectDialog" style="min-width: 10%; margin-left: 2%">{{ quickSelect }}</el-button>

        <el-button type="primary" @click="onSearch" style="min-width: 10%;margin-right: 2%">查询</el-button>
      </div>
    </div>

    <!-- 快速选择模态框 -->
    <el-dialog v-model="quickSelectDialogVisible" title="选择日期" width="30%">
      <div>
        <el-button v-for="option in quickSelectOptions" :key="option.value" style="width: 60%;margin:2%" @click="selectQuickDate(option.value)">
          {{ option.label }}
        </el-button>
      </div>
      <template #footer>
        <el-button @click="quickSelectDialogVisible = false">取消</el-button>
      </template>
    </el-dialog>

    <!-- 可选：按具体分类挑选（保留钩子，但默认统计总体） -->
    <el-dialog v-model="playSelectDialogVisible" title="选择玩法" width="30%" :style="{ top: dialogTop + 'px' }">
      <div>
        <el-button v-for="item in totalPlayOptions" :key="item" style="margin: 5px" @click="selectPlay(item)">
          {{ item }}
        </el-button>
      </div>
      <template #footer>
        <el-button @click="playSelectDialogVisible = false">取消</el-button>
      </template>
    </el-dialog>

    <!-- 总体分析（折线图） -->
    <div style="text-align: center;">
      <h2>总体分析</h2>
      <div style="display: inline-block;">
        <v-chart class="chart-box" :option="lineChartOptions" style="width: 600px; height: 500px;" />
      </div>
    </div>

    <!-- 分类统计（仅在 selectedPlay === 'statists_total' 时展示饼图+表） -->
    <div v-if="selectedPlay === 'statists_total'" style="text-align: center;">
      <h2>玩法分类统计</h2>
      <div style="display: inline-block;">
        <v-chart class="chart-box" :option="pieChartOptions" style="width: 600px; height: 400px; margin-bottom: 20px;" />
      </div>

      <h2>分类上榜数据统计</h2>
      <div style="margin: 0 5% 20px;">
        <el-table :data="tableData" style="width: 100%;" :border="true" :header-row-style="headerRowStyle" :header-cell-style="headerCellStyle" :row-class-name="getRowClassName">
          <el-table-column prop="type"        label="类型"       align="center" />
          <el-table-column prop="score_total" label="总活跃度"   align="center" :formatter="formatScore" />
          <el-table-column prop="game_num"    label="玩法数量"   align="center" />
          <el-table-column prop="anchor_num"  label="上榜主播"   align="center" />
          <el-table-column prop="anchor_average" label="单人活跃" align="center" />
        </el-table>
      </div>

      <div style="text-align: center; margin-bottom: 20px; display: inline-flex; align-items: center; justify-content: center;">
        <label style="margin-right: 8px;">选择日期:</label>
        <el-button @click="showDateDialog" style="width: 200px;">{{ selectedPieDate || '选择日期' }}</el-button>

        <el-dialog v-model="dateDialogVisible" title="选择日期" width="70%" custom-class="centered-dialog" :style="{ top: dialogTop + 'px' }">
          <div>
            <el-button v-for="item in timeSegmentsWithoutTotal" :key="item" style="margin: 10px" @click="selectDate(item)">
              {{ item }}
            </el-button>
          </div>
          <template #footer>
            <el-button @click="dateDialogVisible = false">取消</el-button>
          </template>
        </el-dialog>
      </div>
    </div>

    <!-- 热门玩法占比 -->
    <div style="text-align: center;">
      <h2>热门玩法统计</h2>
      <div style="display: inline-block;">
        <v-chart class="chart-box" :option="hotPieOptions" style="width: 600px; height: 400px; margin-bottom: 20px;" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import axios from 'axios'
import VChart from 'vue-echarts'
import { ElDialog, ElIcon } from 'element-plus'
import { Loading } from '@element-plus/icons-vue'
import { Datetime } from 'vue-datetime3'

// ---- 状态 ----
const queryType = ref('hour')
const startDate = ref(formatDate(new Date()))
const endDate = ref(null)
const quickSelect = ref('今天')

// 玩法选择（默认展示总体）
const selectedPlay = ref('statists_total')
const totalPlayOptions = ref([])

// 饼图日期
const selectedPieDate = ref('')

// 数据
const statisticsList = ref([])
const rankingList = ref([])

// 图表
const lineChartOptions = ref({})
const pieChartOptions = ref({})
const hotPieOptions = ref({})

// 表格
const tableData = ref([])

// 加载弹窗
const isLoading = ref(false)

// 滚动定位
const dialogTop = ref(0)
const dateDialogVisible = ref(false)
const quickSelectDialogVisible = ref(false)
const playSelectDialogVisible = ref(false)

// 时间段（不含 total）
const timeSegmentsWithoutTotal = computed(() =>
    statisticsList.value.filter(item => item.time_segment !== 'total').map(item => item.time_segment)
)

// 标题时间展示
const displayTime = computed(() => {
  if (!startDate.value) return ''
  if (queryType.value === 'day') {
    return endDate.value ? `${formatDate(startDate.value)} ~ ${formatDate(endDate.value)}` : `${formatDate(startDate.value)} ~ `
  } else {
    return formatDate(startDate.value)
  }
})

// 快速选项
const quickSelectOptions = [
  { label: '今天', value: '今天' },
  { label: '昨天', value: '昨天' },
  { label: '前天', value: '前天' }
]

// —— 关键：切换为快手接口 ——
// 后端需提供 /api/ks_dashboard_data（与抖音版返回结构相同）
const KS_DASHBOARD_API = 'https://www.hudongwanfa.cn/api/ks_dashboard_data'

// 查询
const onSearch = async () => {
  if (!startDate.value) {
    alert('请选择开始日期')
    return
  }
  isLoading.value = true
  const params = {
    start_date: formatDate(startDate.value),
    end_date: queryType.value === 'day' && endDate.value ? formatDate(endDate.value) : formatDate(startDate.value),
    query_type: queryType.value === 'hour' ? 'hour' : 'day'
  }
  try {
    const resp = await axios.get(KS_DASHBOARD_API, { params })
    if (resp.data.code === 0) {
      const data = resp.data.data
      statisticsList.value = data.statistics_list || []
      rankingList.value = data.ranking_list || []

      // 玩法分类选项
      const totalItem = statisticsList.value.find(item => item.time_segment === 'total')
      totalPlayOptions.value = []
      if (totalItem && totalItem.statistics) {
        for (let key in totalItem.statistics) {
          if (key !== 'statists_total') totalPlayOptions.value.push(key)
        }
      }
      selectedPlay.value = 'statists_total'

      // 饼图默认日期
      selectedPieDate.value = timeSegmentsWithoutTotal.value[0] || ''

      updateLineChart()
      updatePieAndTable()
      updateHotPieChart()
    } else {
      alert('接口返回错误：' + resp.data.message)
    }
  } catch (err) {
    console.error('请求接口出错 => ', err)
    alert('请求接口失败')
  } finally {
    isLoading.value = false
  }
}

// 折线图
const updateLineChart = () => {
  const list = statisticsList.value.filter(item => item.time_segment !== 'total')
  const xAxisData = list.map(item => item.time_segment)

  const key = selectedPlay.value
  const rawSeriesCurrent = []
  const seriesLast = []

  list.forEach(item => {
    const stat = item.statistics[key]
    if (stat) {
      const s = Number(stat.score_total) || 0
      const sl = Number(stat.score_total_last) || 0
      rawSeriesCurrent.push(s / 10000)
      seriesLast.push(sl / 10000)
    } else {
      rawSeriesCurrent.push(0)
      seriesLast.push(0)
    }
  })

  // 从第一个0开始之后的点置为 null（不连线）
  let cutoff = rawSeriesCurrent.findIndex(v => v === 0)
  let seriesCurrent = cutoff === -1 ? rawSeriesCurrent : [...rawSeriesCurrent.slice(0, cutoff), ...Array(rawSeriesCurrent.length - cutoff).fill(null)]

  lineChartOptions.value = {
    backgroundColor: '#eff1f3',
    title: { text: '大盘活跃数据图', subtext: '单位(万)', left: 'center', top: 20 },
    legend: { data: ['本周期', '上一周期'], top: 70 },
    grid: { top: 100, left: '10%', right: '10%', bottom: '10%' },
    tooltip: { trigger: 'axis' },
    xAxis: { type: 'category', data: xAxisData, boundaryGap: false, axisLabel: { rotate: 45 } },
    yAxis: { type: 'value' },
    series: [
      { name: '本周期', type: 'line', showAllSymbol: true, connectNulls: false, symbolSize: 6, data: seriesCurrent },
      { name: '上一周期', type: 'line', data: seriesLast }
    ]
  }
}

// 饼图 + 分类表格
const updatePieAndTable = () => {
  if (!selectedPieDate.value) {
    pieChartOptions.value = {}
    tableData.value = []
    return
  }
  const item = statisticsList.value.find(i => i.time_segment === selectedPieDate.value)
  if (!item || !item.statistics) {
    pieChartOptions.value = {}
    tableData.value = []
    return
  }

  const stats = item.statistics
  const pieData = []
  const tableArr = []

  for (let key in stats) {
    if (key === 'statists_total') continue
    const cur = stats[key]
    const score_total = Number(cur.score_total) || 0
    const game_num = cur.game_num || 0
    const anchor_num = cur.anchor_num || 0
    const anchor_average = cur.anchor_average || 0

    pieData.push({ name: key, value: score_total })
    tableArr.push({ type: key, score_total, game_num, anchor_num, anchor_average })
  }

  pieChartOptions.value = {
    backgroundColor: '#eff1f3',
    title: { text: '每日玩法占比', left: 'center' },
    tooltip: { trigger: 'item' },
    legend: { orient: 'vertical', left: 'left' },
    series: [{ name: '玩法占比', type: 'pie', radius: '50%', data: pieData }]
  }
  tableData.value = tableArr
}

// 热门玩法饼图
const hotPieColors = ['#a0d7e2','#c7e8b7','#667896','#c6b0c3','#52b6bf','#89d0a6','#bbd48f','#77a4cd','#eeb9b4','#9b7db5']
const updateHotPieChart = () => {
  if (!rankingList.value || rankingList.value.length === 0) {
    hotPieOptions.value = {}
    return
  }
  const hotData = rankingList.value.map((item, idx) => ({
    name: item.game_name,
    value: Number(item.score) || 0,
    itemStyle: { color: hotPieColors[idx] || '#000000' }
  }))

  hotPieOptions.value = {
    backgroundColor: '#eff1f3',
    title: { text: '热门玩法活跃度占比', left: 'center' },
    tooltip: { trigger: 'item' },
    legend: { orient: 'vertical', left: 'left' },
    series: [{ name: '热门玩法', type: 'pie', radius: '50%', data: hotData }]
  }
}

// 工具
function formatScore(row, column, cellValue) {
  const val = Number(cellValue) || 0
  return (val / 10000).toFixed(1) + '万'
}
function formatDate(d) {
  if (!(d instanceof Date)) d = new Date(d)
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

const updateDialogTop = () => {
  const w = window.innerWidth
  dialogTop.value = w <= 768 ? (768 / w) * window.scrollY + 100 : 0
}
onMounted(() => {
  window.addEventListener('scroll', updateDialogTop)
  onSearch()
})
watch(dateDialogVisible, (val) => { if (!val) window.removeEventListener('scroll', updateDialogTop) })

function getRowClassName({ rowIndex }) { return rowIndex % 2 === 0 ? 'even-row' : 'odd-row' }
function headerCellStyle() { return { backgroundColor: '#4a649e', color: 'white', fontWeight: 'bold', textAlign: 'center', fontSize: '16px' } }
function headerRowStyle() { return { backgroundColor: '#f2f2f2', fontWeight: 'bold' } }

const showDateDialog = () => { dateDialogVisible.value = true }
const selectDate = (date) => { selectedPieDate.value = date; dateDialogVisible.value = false; updatePieAndTable() }

const showQuickSelectDialog = () => { quickSelectDialogVisible.value = true }
const selectQuickDate = (value) => {
  quickSelect.value = value
  quickSelectDialogVisible.value = false
  const today = new Date()
  if (value === '今天') {
    startDate.value = formatDate(today)
    endDate.value = null
  } else if (value === '昨天') {
    const y = new Date(); y.setDate(today.getDate() - 1)
    startDate.value = formatDate(y)
    endDate.value = null
  } else if (value === '前天') {
    const by = new Date(); by.setDate(today.getDate() - 2)
    startDate.value = formatDate(by)
    endDate.value = null
  }
}

const selectPlay = (play) => { selectedPlay.value = play; playSelectDialogVisible.value = false; updatePieAndTable() }
</script>

<style scoped>
.chart-box { margin: 20px 0; background-color: #ffe; }
.loading-dialog .el-dialog__header { display: none; }
.el-radio /deep/ .el-radio__label { font-size: 16px; }

.centered-dialog .el-dialog {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  max-height: 80%;
  overflow: auto;
}
</style>
